// src/utils/Onboarding/session.js

/**
 * Returns an ISO 8601 string using UTC timezone with millisecond precision.
 */
export function getUtcIsoTimestamp(dateLike = null) {
  const date = dateLike instanceof Date ? dateLike : dateLike ? new Date(dateLike) : new Date();
  return date.toISOString();
}

function padNumber(value, length = 2) {
  return String(value).padStart(length, '0');
}

function buildSortableTimestamp(dateLike = null) {
  const date = dateLike instanceof Date ? dateLike : dateLike ? new Date(dateLike) : new Date();
  return [
    padNumber(date.getUTCFullYear(), 4),
    padNumber(date.getUTCMonth() + 1, 2),
    padNumber(date.getUTCDate(), 2),
    'T',
    padNumber(date.getUTCHours(), 2),
    padNumber(date.getUTCMinutes(), 2),
    padNumber(date.getUTCSeconds(), 2),
    padNumber(date.getUTCMilliseconds(), 3),
    'Z',
  ].join('');
}

/**
 * Generates a session identifier that sorts lexicographically by creation moment.
 * Example output: 20250203T141533187Z-d0f6b21c
 */
export function generateOnboardingSessionId(dateLike = null) {
  const sortable = buildSortableTimestamp(dateLike);
  const randomSuffix = Math.random().toString(36).slice(2, 10);
  return `${sortable}-${randomSuffix}`;
}

export function describeSession(sessionId, createdAt = null) {
  return {
    sessionId,
    createdAt: createdAt ?? getUtcIsoTimestamp(),
  };
}
